var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "200px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E2E0"
    },
    points: "121.796,269.608 73.119,344.219 167.78,438.881 242.391,390.203 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EE3840"
    },
    points: "403.094,264.221 247.778,108.905 110.445,130.358 25.05,215.753 136.255,220.429 291.571,375.745 296.246,486.95 381.641,401.555 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCC4C1"
    },
    d: "M504.825,7.176c-91.794-25.474-177.32,22.004-217.459,62.143 c-11.993,11.992-191.31,191.309-191.31,191.309l155.316,155.316c0,0,162.336-162.336,191.309-191.309 C482.819,184.496,530.298,98.969,504.825,7.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE3840"
    },
    d: "M152.269,359.731c-4.628-4.628-4.628-12.133,0-16.761l164.787-164.787 c4.628-4.628,12.133-4.628,16.761,0c4.628,4.628,4.628,12.133,0,16.761L169.03,359.731 C164.401,364.359,156.897,364.36,152.269,359.731z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 403.105,
    cy: 108.895,
    r: 43.796
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB14D"
    },
    d: "M3.471,432.083c-4.628-4.628-4.628-12.133,0-16.761l45.234-45.234 c4.628-4.628,12.133-4.628,16.761,0c4.628,4.628,4.628,12.133,0,16.761l-45.234,45.234C15.604,436.711,8.099,436.712,3.471,432.083 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB14D"
    },
    d: "M79.917,508.528c-4.628-4.628-4.628-12.133,0-16.761l45.234-45.234 c4.628-4.628,12.133-4.628,16.761,0s4.628,12.133,0,16.761l-45.234,45.234C92.049,513.157,84.545,513.157,79.917,508.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB14D"
    },
    d: "M22.632,487.679c-4.628-4.628-4.628-12.133,0-16.761l63.45-63.45c4.628-4.628,12.133-4.628,16.761,0 c4.628,4.628,4.628,12.133,0,16.761l-63.45,63.45C34.765,492.307,27.261,492.307,22.632,487.679z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7376fc17485fc425f219112a42afa901.svg";
export { ForwardRef as ReactComponent };